import { titleColor } from "@/lib/profiles";

// Small colored title chip shown next to a username. Color is pro-aware:
// Fan/Dad/Mom grey, Athlete purple; Coach/Director orange, Trainer blue, Scout red
// (only on Pro accounts — grey on Standard).
export default function TitleTag({ title, isPro = false, className = "" }) {
    if (!title) return null;
    return (
        <span
            data-testid="author-title"
            className={`uppercase tracking-[0.12em] text-[10px] font-bold shrink-0 ${className}`}
            style={{ color: titleColor(title, isPro) }}
        >
            {title}
        </span>
    );
}
